module.exports = __webpack_public_path__ + "static/media/detalhes.1e4a3a2c.svg";